// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import DeliveryDetails from './DeliveryDetails';
import './DeliveryDetailsModal.scss';

export default function DeliveryDetailsModal({ show, onHide, deliveryId, deliveriesSettings }) {
    const { t } = useTranslation();
    
    return (
        <Modal 
            className="delivery-details-modal"
            show={show}
            onHide={onHide}
            size="lg"
            centered
            backdrop="static"
            animation={true}
        >
            <Modal.Header closeButton>
                <Modal.Title>{`${t("delivery_title")} #${deliveryId}`}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <DeliveryDetails 
                    deliveryId={deliveryId} 
                    deliveriesSettings={deliveriesSettings} 
                />
            </Modal.Body>
        </Modal>
    );
} 